<template>
  <div>

    <v-app-bar id="appMainToolbar" app flat clipped-left :height="testServerName ? 85: 65" :class="isMobileOnly ? 'mobile' : ''"
      :extended="toolbarSearchShown" :scroll-off-screen="isMobileOnly" :scroll-threshold="150" :hide-on-scroll="isHideOnScroll">

      <template v-if="toolbarSearchShown" v-slot:extension>
        <app-text-field v-model="seachValue" class="search-input app-text-field" @keydown.native.enter.stop="searchData" hide-details
          clearable autofocus>
          <template v-slot:prepend-inner>
            <div class="v-input__icon">
              <v-icon :color="seachValue ? 'primary' : 'secondary'" @click="searchData">fa-search</v-icon>
            </div>
          </template>
        </app-text-field>
      </template>

      <v-layout column class="fill-height">
        <v-flex shrink v-if="testServerName" class="text-center text-body-1 error--text">
          {{$t('header.testMode')}}&nbsp;{{testServerName}}
          <v-btn v-if="isDevelopment && !isMobileOnly" small text color="primary" @click="refreshToken">Refresh token</v-btn>
        </v-flex>
        <v-divider v-if="testServerName"></v-divider>
        <v-flex class="d-flex align-center">
          <v-layout align-center class="fill-height">
            <v-toolbar-items>
              <v-app-bar-nav-icon large @click="toggleDrawer" class="sandwich"></v-app-bar-nav-icon>
            </v-toolbar-items>

            <logo class="logo mx-4" :class="isMobileOnly ? 'mt-2' : ''" @click.native="goHome" :width="isMobileOnly ? '5em' : ''"
              :container-width="isMobileOnly ? '' : '143px'" text-align="left"></logo>

            <v-text-field v-if="!isMobileOnly && !isSearchPage" v-model="seachValue" class="search-input app-text-field"
              @keydown.enter.stop="searchData" hide-details clearable>
              <template v-slot:prepend-inner>
                <div class="v-input__icon">
                  <v-icon :color="seachValue ? 'primary' : 'secondary'" @click="searchData">fa-search</v-icon>
                </div>
              </template>
            </v-text-field>

            <v-icon v-if="isMobileOnly && !isSearchPage" color="secondary" class="mobile-search" @click="toggleMobileSearchToolbar">
              fa-search</v-icon>

            <v-spacer></v-spacer>

            <app-tooltip>
              <div v-if="isRoamingBtnVisible" @click="goToMainAskodOnline" class="systems-icon">
                <v-img :src="`${baseUrl}static/systems/askod_online/ico.svg`" contain width="48" height="48"></v-img>
              </div>
              <template v-slot:tooltip> {{$t('header.gotoMainSystem')}}</template>
            </app-tooltip>

            <v-divider v-if="!isMobileOnly" vertical class="mx-2 divider-transparent"></v-divider>

            <app-header-tech-support-btn v-if="showTechSupportBtn" class="mr-2"></app-header-tech-support-btn>

            <v-btn v-if="showGoToReferralLinksBtn" icon small class="mr-2" @click="goToReferralLinks">
              <v-icon small>fa-user-plus</v-icon>
            </v-btn>

            <app-help-button :class="[isMainSystem ? 'mr-2' : '']"></app-help-button>

            <v-btn icon small @click="goToNotifications">
              <v-badge :value="counters && counters.notificationUnread > 0" right overlap color="transparent" class="notifications-badge"
                :class="isMobileOnly ? 'mobile' : ''" >
                <template v-slot:badge>
                  <span class="font-weight-bold primary--text">{{ counters.notificationUnread }}</span>
                </template>
                <v-icon small>fa-bell</v-icon>
              </v-badge>
            </v-btn>

            <v-divider vertical class="mx-2 divider-transparent"></v-divider>

            <header-menu @onselectmenu="selectMenu">
            </header-menu>
          </v-layout>
        </v-flex>
      </v-layout>

    </v-app-bar>

    <select-myorganisation-dlg v-if="myOrgDlgRendered" v-model="myOrgDlgShown" @myOrgSelected="onMyOrgSelected">
    </select-myorganisation-dlg>

  </div>
</template>

<script>
import AppTextField from '@/components/Common/AppTextField';
import AppTooltip from '@/components/Common/AppTooltip';
import Logo from '@/components/Common/Logo.vue';
import HeaderMenu from '@/components/Menu/HeaderMenu';
import uiMixin from '@/mixins/ui-mixin';
import { SupportRequestType } from '@/models/enums';
import { actions as _act } from '@/models/store.actions';
import { userSettingsService } from '@/services/usersettings.service';
import AppHelpButton from '@/components/Common/AppHelpButton';
import SelectMyorganisationDlg from '@/components/Dialogs/SelectMyOrganisationDlg';
import { isDevelopment } from '@/helpers';
import { globalSettingsHelper } from '@/helpers/settings-helper';
import AppHeaderTechSupportBtn from '@/components/Main/AppHeaderTechSupportBtn.vue';
import { routerHelper } from '@/helpers/router.helper';

export default {
  name: 'AppHeader',
  components: { AppHeaderTechSupportBtn, AppTextField, AppTooltip, Logo, AppHelpButton, SelectMyorganisationDlg, HeaderMenu },
  mixins: [uiMixin],
  inject: ['isMobileOnly', 'baseUrl', 'isNativeApp'],
  props: ['miniVariant'],
  data() {
    return {
      toolbarSearchShown: false,
      myOrgDlgRendered: false,
      myOrgDlgShown: false
    };
  },
  computed: {
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    counters() {
      return this.$store.getters[_act.DOC_GET_COUNTERS] || {};
    },
    isSearchPage() {
      return this.$route.name === 'search';
    },
    seachValue: {
      set(value) {
        this.$store.dispatch(_act.DOC_ACT_SETFINDSTRING, { findString: value });
      },
      get() {
        return this.$store.getters[_act.DOC_GET_FINDSTRING];
      }
    },
    testServerName() {
      return this.appSettings ? this.appSettings.testServerName : '';
    },
    userAvatar() {
      return this.$store.getters[_act.AUTH_GET_AVATAR];
    },
    isMainSystem() {
      return this.appSettings && this.appSettings.systemName === 'askod_online';
    },
    isHideOnScroll() {
      return this.isMobileOnly && !this.isNativeApp;
    },
    isDevelopment() {
      return isDevelopment();
    },
    userActions() {
      return this.$store.getters[_act.AUTH_GET_ACTIONSGET] || [];
    },
    allowReferralLinks() {
      return this.userActions.includes(14000) && globalSettingsHelper.isReferralLinkEnabled;
    },
    showGoToReferralLinksBtn() {
      return this.allowReferralLinks && !this.isMobileOnly;
    },
    showTechSupportBtn() {
      return !this.isMobileOnly && globalSettingsHelper.isInfoPlusSystem;
    },
    isRoamingBtnVisible() {
      return !this.isMainSystem && globalSettingsHelper.isRoamingEnabled;
    }
  },
  methods: {
    goToMainAskodOnline() {
      this.$router.push({ name: 'roumingCreate' });
    },
    async changeLang(newLanguage) {
      let loader = this.showLoading();
      try {
        await userSettingsService.changeLocale(newLanguage);
        await this.$store.dispatch(_act.USETT_ACT_USERSETTINGS);

        this.$store.commit(_act.SETT_MUT_LOCALESET, newLanguage);
        this.$i18n.locale = newLanguage;
        this.$vuetify.lang.current = newLanguage;
      } catch (error) {
        // ignored
      } finally {
        loader.hide();
      }
    },
    goHome(e) {
      routerHelper.navigateToHomeView(e.ctrlKey);
    },
    goToNotifications() {
      routerHelper.navigateToNotifications();
    },
    logout() {
      let loader = this.showLoading();
      this.$store.dispatch(_act.AUTH_ACT_LOGOUT).finally(loader.hide);
    },
    searchData() {
      if (this.isMobileOnly) {
        this.toggleMobileSearchToolbar();
      }
      this.$router.push({
        path: '/search/7000/0',
        query: { findString: this.$store.getters[_act.DOC_GET_FINDSTRING] }
      });
    },
    selectMenu(item) {
      switch (item.id) {
        case 'cabinet':
          if (this.$route.name !== 'personal') {
            this.$router.push({ name: item.id });
          }
          break;
        case 'organization':
          let tab = 'info';
          if (tab !== this.$route.name) {
            this.$router.push({ name: tab });
          }
          break;
        case 'logs':
        case 'contacts':
          if (this.$route.name !== item.id) {
            this.$router.push({ name: item.id });
          }
          break;
        case 'support':
          this.sendSupportRequest();
          break;
        case 'language':
          this.changeLang(item.value);
          break;
        case 'logout':
          this.logout();
          break;
        case 'selectMyOrganization':
          this.showMyOrganizationDlg();
          break;
        case 'allMyOrganization':
          this.selectAllMyOrganizations();
          break;
        case 'referralLinks':
          this.goToReferralLinks();
          break;
        default:
          break;
      }
    },
    sendSupportRequest() {
      this.$router.push({
        name: 'supportRequest',
        query: { mode: SupportRequestType.Request }
      });
    },
    toggleDrawer() {
      this.$emit('toggleMenu');
    },
    toggleMobileSearchToolbar() {
      if (!this.isSearchPage) {
        this.toolbarSearchShown = !this.toolbarSearchShown;
      }
    },
    showMyOrganizationDlg() {
      this.myOrgDlgRendered = true;
      this.myOrgDlgShown = true;
    },
    onMyOrgSelected(data) {
      if (data && data.code) {
        this.$store.commit(
          _act.ORG_MUT_MYORGSET,
          {
            myOrganization: {
              code: data.code,
              name: data.fullName
            }
          });
      }
      this.myOrgDlgShown = false;
    },
    selectAllMyOrganizations() {
      this.$store.commit(_act.ORG_MUT_MYORGCLEAR);
    },
    refreshToken() {
      this.$store.dispatch(_act.AUTH_ACT_REFRESHTOKEM);
    },
    goToReferralLinks() {
      if (this.$route.name !== 'referralLinks') {
        this.$router.push({ name: 'referralLinks' });
      }
    }
  }
};
</script>

<style lang="scss">
#appMainToolbar {
  background-color: #ffffff;
  .v-toolbar__content {
    padding: 0;
  }
  .sandwich .v-icon {
    color: #1f1f1f;
  }
  .logo {
    cursor: pointer;
  }
  .v-toolbar__content {
    border-bottom: 1px solid #f0f3f4;
    padding-left: 0;
    padding-right: 0;
  }
  .v-toolbar__items {
    justify-content: center;
    .v-icon {
      font-size: 2.25em;
    }
    .v-btn:before {
      background-color: transparent;
    }
  }
  &:not(.mobile) .v-toolbar__items {
    width: 80px;
  }
  &.mobile {
    .v-toolbar__items .v-icon {
      font-size: 1.5em;
    }
  }

  .v-text-field.search-input {
    max-width: 30vw;
    .v-input__slot {
      background-color: var(--v-app-colors-background-base);
      border: 0;
    }
    &.v-input--is-focused .v-input__slot {
      background-color: var(--v-app-colors-background-light-base);
      border: 1px solid var(--v-primary-base);
    }
  }

  .mobile-search {
    font-size: 1.3em;
    cursor: pointer;
  }
  .fa-bell,
  .fa-user-plus,
  .fa-question-circle,
  .fa-headphones,
  .mobile-search {
    color: var(--v-app-colors-icon-inactive-base);
  }
  .user-name {
    cursor: pointer;
    max-width: 300px;
  }
  .v-avatar {
    span {
      font-size: 200%;
      font-weight: bold;
    }
  }
  .notifications-badge {
    .v-badge__badge {
      color: var(--v-app-colors-text-base);
    }
    &.mobile .v-badge__badge {
      top: -10px;
      right: 0;
    }
    &:not(.mobile) .v-badge__badge {
      top: -12px;
      right: -10px;
    }
  }

  .divider-transparent {
    border: none;
  }
  .systems-icon {
    cursor: pointer;
  }
}
</style>
